import React from "react";
import {
  fetchClippingGameVideos,
  fetchClippingMemeHooks,
  fetchClippingMusic,
  fetchClippingTemplates,
} from "../api/clippingApi";

const EMPTY = {
  templates: [],
  defaultTemplateId: "",
  music: [],
  gameVideos: [],
  memeHooks: [],
  loading: true,
  error: null,
};

/** Session-scoped cache so tab switches don't refetch asset lists. */
let sessionCache = null;

/**
 * @param {Function} hitAxios
 */
export function useAssetLists(hitAxios) {
  const [state, setState] = React.useState(sessionCache || EMPTY);

  React.useEffect(() => {
    if (sessionCache) {
      setState(sessionCache);
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        const [tpl, mus, gv, mh] = await Promise.all([
          fetchClippingTemplates(hitAxios),
          fetchClippingMusic(hitAxios),
          fetchClippingGameVideos(hitAxios),
          fetchClippingMemeHooks(hitAxios),
        ]);

        if (cancelled) return;

        const next = {
          templates: Array.isArray(tpl?.templates) ? tpl.templates : [],
          defaultTemplateId: String(tpl?.defaultTemplateId || ""),
          music: Array.isArray(mus?.music) ? mus.music : [],
          gameVideos: Array.isArray(gv?.gameVideos) ? gv.gameVideos : [],
          memeHooks: Array.isArray(mh?.memeHooks) ? mh.memeHooks : [],
          loading: false,
          error: null,
        };
        sessionCache = next;
        setState(next);
      } catch (err) {
        if (cancelled) return;
        setState((s) => ({
          ...s,
          loading: false,
          error: err?.message || "Could not load clipping assets.",
        }));
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [hitAxios]);

  return state;
}
